export default "__VITE_ASSET__DUh$5j72__"